<!--
 * @Autor: syq
 * @Date: 2021-07-11 15:22:57
-->
<template>
  <div class="storedetails">
    <div v-for="item in data" :key="item.id">
      <div class="top">
        <div class="left">
         <img :src="findlogo(item)" />
        </div>
        <div class="right">
          <div class="right-top">
            <h4>{{ item.name }}</h4>
          </div>
          <div class="right-content">
            <p>
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
      <div class="store-address">
        <div class="store-message">{{ item.remark }}</div>
      </div>
      <!-- <div class="store-details">
        <p>
          厂址:
          <span>广东省广州市天河区xx厂区xx工厂</span>
        </p>
        <p>
          经营类目:
          <span>日化、洁净用品</span>
        </p>
        <p>工厂规模</p>
      </div> -->
      <div class="stroe-img">
        <!-- <img :src="JSON.parse(item.ext)" alt="" /> -->
      </div>
    </div>
    <van-loading size="24px" v-show="storedetail" vertical
      >加载中...</van-loading
    >
  </div>
</template>

<script>
import { queryTreeNode } from "./service";
import icon from "../../../assets/icon/screening_done_icon@1x.png";


export default {
  data() {
    return {
      data: [],
      storeId: "",
      seconedId: "",
      storedetail: false,
      icon: icon
    };
  },

  mounted() {
    this.getTreeNode();
  },
  methods: {
    async getTreeNode() {
      if (localStorage.getItem("storeCodeclass") || localStorage.getItem("storeCodeclass")) {
        this.storedetail = true;
        await queryTreeNode(
          localStorage.getItem("storeCodeclass") || localStorage.getItem("storeCodeclass")
        ).then((res) => {
          this.storedetail = false;
          if (res.status === "0") {
            this.data = res?.data?.items;
            localStorage.setItem("storeCodeclass", res?.data?.items[0]?.code || "");
          }
        });
      }
    },
    findlogo(item){
      return item?.ext ? JSON.parse(JSON.parse(item.ext).logo)[0].thumbUrl : 'http://www.liby.com.cn/images/logo.png'
    }
  },
};
</script>

<style lang="less" scoped>
.storedetails {
  width: 100%;
  margin: 8px 0 0 0;
  border-radius: 8px;
  overflow: hidden;
  .top {
    padding: 0 16px 0 16px;
    width: 100%;
    display: flex;
    height: 112px;
    background-color: #fff;
    .left {
      padding: 20px;
      img {
        width: 85px;
        height: 85px;
      }
    }
    .right {
      flex: 1;
      .right-top {
        width: 100%;
        height: 24px;
        padding: 8px 0 0 0;
        width: 192px;
        height: 20px;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        h4 {
          font-size: 14px;
        }
      }
      .right-content {
        width: 100%;
        margin-top: 5px;
        p {
          margin: 0;
          font-size: 12px;
          color: #96979b;
        }
      }
    }
  }
  .store-address {
    margin-top: 8px;
    width: 100%;
    background-color: #ffffff;
    padding: 0 16px 0 16px;
    .store-message {
      // height: 48px;
      // font-size: 14px;
      // font-weight: 400;
      // line-height: 48px;
      padding: 16px 16px 16px 16px;
      font-size: 12px;
      color: #1c2529;
      opacity: 0.56;
      margin: 0 auto;
    }
  }
  .store-details {
    background-color: #ffffff;
    height: 104px;
    margin-top: 1px;
    font-size: 12px;
    color: #1c2529;
    opacity: 0.56;
    padding: 8px 16px 0px 16px;
  }
  .stroe-img {
    height: 160px;

    img {
      width: 100%;
      height: 160px;
    }
  }
}
</style>
